import { createSignal, JSX, onCleanup } from 'solid-js';

interface CollapsePanelProps {
    header: string;
    children: JSX.Element;
}

export default function CollapsePanel(props: CollapsePanelProps) {
    const [isOpen, setIsOpen] = createSignal(false);
    let contentRef: HTMLDivElement | undefined;

    const togglePanel = () => {
        if (contentRef) {
            if (isOpen()) {
                contentRef.style.maxHeight = '0';
            } else {
                contentRef.style.maxHeight = contentRef.scrollHeight + 'px';
            }
        }
        setIsOpen(!isOpen());
    };

    onCleanup(() => {
        if (contentRef) contentRef.style.maxHeight = '0';
    });

    return (
        <div class="collapse-panel">
            <div class="collapse-header" onClick={togglePanel}>
                <h3>{props.header}</h3>
                <span class="toggle-icon">{isOpen() ? '-' : '+'}</span>
            </div>
            <div class="collapse-content" ref={contentRef}>
                {props.children}
            </div>
        </div>
    );
}
